import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private translate = inject(TranslateService);
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private loadingMessageSubject = new BehaviorSubject<string>('Carregando...');
  private loadingTimeout?: any;
  
  public readonly isLoading$ = this.isLoadingSubject.asObservable();
  public readonly loadingMessage$ = this.loadingMessageSubject.asObservable();

  constructor() {
    // Initialize with translated default message
    this.updateDefaultMessage();
    
    // Listen for language changes
    this.translate.onLangChange.subscribe(() => {
      this.updateDefaultMessage();
    });
  }

  private updateDefaultMessage() {
    const translatedMessage = this.translate.instant('loading.default');
    this.loadingMessageSubject.next(translatedMessage);
  }

  show(message?: string) {
    const loadingMessage = message || this.translate.instant('loading.default');
    console.log('🔄 LoadingService.show() chamado:', loadingMessage);
    
    // Limpa timeout anterior se existir
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
    
    this.loadingMessageSubject.next(loadingMessage);
    this.isLoadingSubject.next(true);
    console.log('✅ LoadingService: Estado alterado para true');
    
    // Timeout de segurança para evitar loading infinito (10 segundos)
    this.loadingTimeout = setTimeout(() => {
      console.log('⚠️ LoadingService: Timeout de segurança ativado, escondendo loading');
      this.hide();
    }, 10000);
  }

  hide() {
    console.log('🔄 LoadingService.hide() chamado');
    
    // Limpa timeout se existir
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = undefined;
    }
    
    this.isLoadingSubject.next(false);
    console.log('✅ LoadingService: Estado alterado para false');
  }

  setMessage(message: string) {
    this.loadingMessageSubject.next(message);
  }
}


